// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IReplyActionSchema {
  /** Взаимодействие с отзывов **/
  replyActionType: EReplyActionType;
}

export enum EReplyActionType {
  /** Появляется кнопка ответить **/
  'Comment' = 'comment',
}
